// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"SearchTags_tagWrapper__ksVvk","tag":"SearchTags_tag__O_1jG","deleteIcon":"SearchTags_deleteIcon__45LMA","tagLabel":"SearchTags_tagLabel__d47Om"};